'use client';

import { getScrollBehavior } from '@shared/utils';
import { type Dispatch, type RefObject, type SetStateAction, useEffect } from 'react';
import type { MonthKey, ScrollTarget } from '../../types';

function useScrollToTarget(wrapperRef: RefObject<HTMLDivElement | null>, scrollTarget: ScrollTarget, monthKey: MonthKey, setScrollTarget: Dispatch<SetStateAction<ScrollTarget>>) {
  useEffect(() => {
    if (scrollTarget === monthKey) {
      wrapperRef.current?.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
      setScrollTarget(null);
    }
  }, [monthKey, scrollTarget, setScrollTarget, wrapperRef]);
}

export { useScrollToTarget };
